const PLATFORM_ADMIN_PRODUCTION_HOST = 'https://platform-admin.blocktickets.xyz'
const PLATFORM_ADMIN_PREVIEW_HOST =
  'https://preview-platform-admin.blocktickets.xyz'
const PLATFORM_ADMIN_LOCAL_HOST = 'http://localhost:3003'

function platformAdminHost({ env = process.env, hostname = '' } = {}) {
  const configured = String(env.REACT_APP_PLATFORM_ADMIN_HOST || '')
    .trim()
    .replace(/\/$/, '')
  if (configured) return configured

  const stage = String(env.REACT_APP_STAGE || '')
    .trim()
    .toLowerCase()
  const host = String(hostname || '')
    .trim()
    .toLowerCase()

  if (stage === 'production' || host === 'admin.blocktickets.xyz') {
    return PLATFORM_ADMIN_PRODUCTION_HOST
  }
  if (stage === 'preview' || host.includes('preview')) {
    return PLATFORM_ADMIN_PREVIEW_HOST
  }
  return PLATFORM_ADMIN_LOCAL_HOST
}

/**
 * Old Slack links landed on the organizer admin as `/?orderSearch={orderId}`.
 * Returns the platform-admin order URL, or null when the query is absent.
 */
function legacyOrderSearchRedirectUrl(search, options) {
  const raw = String(search || '')
  const query = raw.startsWith('?') ? raw.slice(1) : raw
  const orderId = new URLSearchParams(query).get('orderSearch')?.trim() ?? ''
  if (!orderId) return null
  return `${platformAdminHost(options)}/orders/${encodeURIComponent(orderId)}`
}

export {
  PLATFORM_ADMIN_PRODUCTION_HOST,
  PLATFORM_ADMIN_PREVIEW_HOST,
  PLATFORM_ADMIN_LOCAL_HOST,
  platformAdminHost,
  legacyOrderSearchRedirectUrl,
}
